import { render, staticRenderFns } from "./AdditionalRoomService.vue?vue&type=template&id=bd96ef78"
import script from "./AdditionalRoomService.vue?vue&type=script&lang=js"
export * from "./AdditionalRoomService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports